import Login from '../components/login/Login';
import useDocumentTitle from '../hooks/useDocumentTitle';

const LoginPage: React.FC = () => {
    useDocumentTitle('Login');
    return <Login />;
};
export default LoginPage;
